import { render, staticRenderFns } from "./LoopChooseCom.vue?vue&type=template&id=cbb31e98&"
import script from "./LoopChooseCom.vue?vue&type=script&lang=ts&"
export * from "./LoopChooseCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports